// 변경공사를 만들 수 없거나(new) 작성 중인 건을 더 진행할 수 없는(draft) 자리의 안내 — 판정은 canStartChangeOrder 한 벌, 여기서는 이유·다음 할 일만 붙인다.

import {
  CHANGE_ORDER_CONTRACT_NOT_SIGNED_MESSAGE,
  CHANGE_ORDER_PROJECT_INACTIVE_MESSAGE,
} from "./messages";
import { canStartChangeOrder } from "./view";
import type { Contract } from "../contract/rows";
import { CONTRACT_STATUS_LABEL } from "../contract/types";
import { PROJECT_STATUS_LABEL, type ProjectStatus } from "../project/types";

export interface ChangeOrderStartBlock {
  message: string;
  hint: string;
  next: { label: string; href: string }[];
}

export type ChangeOrderBlockTarget = "new" | "draft";

export const changeOrderStartBlock = (
  contract: Pick<Contract, "id" | "status">,
  project: { id: string; status: ProjectStatus } | null,
  target: ChangeOrderBlockTarget = "new"
): ChangeOrderStartBlock | null => {
  if (canStartChangeOrder(contract.status, project?.status)) return null;
  const draft = target === "draft";
  const toContract = { label: "계약 보기", href: `/app/contracts/${contract.id}` };
  const toProject = project ? [{ label: "현장 보기", href: `/app/projects/${project.id}` }] : [];
  if (contract.status !== "SIGNED") {
    const ended = `이 계약은 「${CONTRACT_STATUS_LABEL[contract.status]}」 상태라`;
    const hint = draft
      ? `${ended} 이 변경공사는 더 고치거나 보낼 수 없습니다.`
      : contract.status === "DRAFT"
        ? "계약서를 보내 고객 서명을 받으면 만들 수 있습니다."
        : contract.status === "SENT"
          ? "고객이 계약서에 서명하면 만들 수 있습니다."
          : `${ended} 더는 변경공사를 만들 수 없습니다.`;
    return {
      message: CHANGE_ORDER_CONTRACT_NOT_SIGNED_MESSAGE,
      hint,
      next: draft ? [toContract, ...toProject] : [toContract],
    };
  }
  if (!project) {
    return {
      message: CHANGE_ORDER_PROJECT_INACTIVE_MESSAGE,
      hint: draft
        ? "이 계약에는 현장이 없어 이 변경공사를 보내거나 승인할 수 없습니다."
        : "이 계약에는 아직 현장이 없습니다 — 계약 화면에서 현장을 먼저 만들어 주세요.",
      next: [toContract],
    };
  }
  const state = `이 현장은 「${PROJECT_STATUS_LABEL[project.status]}」 상태라`;
  return {
    message: CHANGE_ORDER_PROJECT_INACTIVE_MESSAGE,
    hint: draft
      ? `${state} 이 변경공사는 보내거나 승인할 수 없습니다 — 필요 없으면 파기해 주세요.`
      : `${state} 변경공사를 만들 수 없습니다.`,
    next: [...toProject, toContract],
  };
};
